module.exports = __webpack_public_path__ + "static/media/icon_wufajiance.e071d592.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_wufajiance.svg
// module id = 252
// module chunks = 0